import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Payer } from '../../model/payer';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { Contact } from '../../model/contact';
import { ContactBalanceTransactionService } from '../../../invoice/service/data/contact-balance-transaction.service';
import { PaymentMethodService } from '../../../invoice/service/data/payment-method.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { LocalDate } from '../../../core/model/local-date';
import { switchMap, tap } from 'rxjs/operators';
import { ContactService } from '../../service/data/contact.service';
import { MessageService } from '../../../core/service/message.service';
import { DwellingService } from '../../service/data/dwelling.service';
import { IAutoCompleteService } from '../../../core/component/autocomplete-remote/autocomplete-remote.component';

@Component({
    selector: 'app-copy-rooms-form',
    templateUrl: './copy-rooms-form.component.html',
    styleUrls: ['./copy-rooms-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CopyRoomsFormComponent implements OnInit {
  constructor(
    private _dialogService: ActionWindowService,
    private _dwellingService: DwellingService,
    private _messageService: MessageService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {}

  @Input() dataContext: { filter: any; includedIds: string[]; excludedIds: string[]; affectedItemsCount: number };

  form: FormGroup;

  cancel() {
    this._dialogService.close();
  }

  get dwellingAutoCompleteService(): IAutoCompleteService {
    return this._dwellingService;
  }

  ngOnInit() {
    this.form = this._fb.group({
      rentalObjectId: this._fcf.createMandatory('RENTAL_OBJECT.COPY_ROOMS_FROM', null, 'RENTAL_OBJECT.HELP_TEXT.COPY_ROOMS_FROM'),
      overwrite: this._fcf.create('RENTAL_OBJECT.COPY_OVERWRITE', false, null, null, 'RENTAL_OBJECT.HELP_TEXT.COPY_OVERWRITE'),
    });
  }

  private _working = false;
  onSubmit() {
    if (this.form.invalid || this._working) return;

    this._working = true;
    const values = this.form.value;
    const model = {
      filter: this.dataContext.filter,
      includedIds: this.dataContext.includedIds,
      excludedIds: this.dataContext.excludedIds,
      affectedItemsCount: this.dataContext.affectedItemsCount,
    };
    this._dwellingService.copyRooms(this.form.controls['rentalObjectId'].value, model, this.form.controls['overwrite'].value).subscribe(
      res => {
        this._messageService.showSuccess();
        this._dialogService.complete(res);
      },
      () => {
        this._working = false;
      }
    );
  }
}
